// this is an autogenerated file from App/Account/Content/Tasks/New/Content/Board/Content/Main/Subscribers/mutation-add-subscribers.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks_New_Content_Board_Content_Main_Subscribers(
  $objects: [tasks_subscribers_insert_input!]!
) {
  insert_tasks_subscribers(objects: $objects) {
    returning {
      id
    }
  }
}

`